__turbopack_context__.v({
  "about": "Space-module-scss-module__fAs_cq__about",
  "bottomLinks": "Space-module-scss-module__fAs_cq__bottomLinks",
  "info": "Space-module-scss-module__fAs_cq__info",
  "join": "Space-module-scss-module__fAs_cq__join",
  "section": "Space-module-scss-module__fAs_cq__section",
  "sectionAdv": "Space-module-scss-module__fAs_cq__sectionAdv",
  "sectionLink": "Space-module-scss-module__fAs_cq__sectionLink",
  "sectionWhy": "Space-module-scss-module__fAs_cq__sectionWhy",
  "subtitle": "Space-module-scss-module__fAs_cq__subtitle",
  "title": "Space-module-scss-module__fAs_cq__title",
});
